import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "data",
      description: "按钮组数据，必须含有label字段，其他载荷任意",
      type: "Array"
    },
    {
      prop: "pageSize",
      description: "分页单元显示的按钮数量",
      type: "Number",
      default: 5
    },
    {
      prop: "itemSize",
      description: "按钮尺寸",
      type: "Number",
      default: 100
    },
    {
      prop: "spaceSize",
      description: "按钮间距",
      type: "Number",
      default: 15
    }
  ],
  events: [],
  methods: [
    {
      name: "select",
      description: "按钮点击事件",
      argument: "点击的按钮对象"
    }
  ],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
